module.exports = {"130426001":"平安街道","130426100":"涉城镇","130426101":"河南店镇","130426102":"索堡镇","130426103":"西戌镇","130426104":"井店镇","130426105":"更乐镇","130426106":"固新镇","130426107":"西达镇","130426108":"偏城镇","130426200":"神头乡","130426201":"辽城乡","130426202":"偏店乡","130426203":"龙虎乡","130426204":"木井乡","130426205":"关防乡","130426206":"合漳乡","130426207":"鹿头乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130426.json
// module id = 107
// module chunks = 0